import { colorTextByBg, mods, theme } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import styled, { css } from 'styled-components';

import { PageWrapperProps } from './PageWrapper.types';

export const Root = styled.div<StyledMods<Pick<PageWrapperProps, 'direction' | 'color'>>>`
    display: flex;
    flex-flow: ${({ $direction }) => $direction};
    height: 100%;
    overflow: hidden;
    position: relative;
    ${mods.color(
        (value) => css`
            background-color: ${theme.color[value]};
            color: ${theme.color[colorTextByBg[value]]};
        `
    )};
`;
